import audifonosgomitaportada from '../assets/images/products/audifonos-gomita-portada.jpg';
import audifonosgomita1 from '../assets/images/products/audifonos-gomita1.jpg';
import audifonosgomita2 from '../assets/images/products/audifonos-gomita2.jpg';
import audifonosinearportada from '../assets/images/products/aufionos-inear-portada.jpg';
import audifonosinear1 from '../assets/images/products/audifonos-inear1.jpg';
import audifonosinear2 from '../assets/images/products/audifonos-inear2.jpg';
import cargadorportada from '../assets/images/products/cargador-portada.jpg';
import cargador1 from '../assets/images/products/cargador1.jpg';
import cargador2 from '../assets/images/products/cargador2.jpg';
import cargador3 from '../assets/images/products/cargador3.jpg';
import cargador67wportada from '../assets/images/products/cargador67w-portada.jpeg';
import cargador67w1 from '../assets/images/products/cargador67w1.jpeg';
import cargador67w2 from '../assets/images/products/cargador67w2.jpeg';
import cargador67w3 from '../assets/images/products/cargador67w3.jpeg';
import cargador67w4 from '../assets/images/products/cargador67w4.jpeg';
import cargador67w5 from '../assets/images/products/cargador67w5.jpeg';
import cargador67w6 from '../assets/images/products/cargador67w6.jpeg';
import cargador120wportada from '../assets/images/products/cargador120w-portada.jpg';
import cargador120w1 from '../assets/images/products/cargador120w1.jpeg';
import cargador120w2 from '../assets/images/products/cargador120w2.jpeg';
import cargador120w3 from '../assets/images/products/cargador120w3.jpeg';
import cargador120w4 from '../assets/images/products/cargador120w4.jpeg';
import cargador120w5 from '../assets/images/products/cargador120w5.jpeg';
import cargador120w6 from '../assets/images/products/cargador120w6.jpeg';
// import botellaportada from '../assets/images/products/botella-portada.jpeg';
// import botella1 from '../assets/images/products/botella1.jpeg';
// import botella2 from '../assets/images/products/botella2.jpeg';
// import botella3 from '../assets/images/products/botella3.jpeg';
// import botella4 from '../assets/images/products/botella4.jpeg';
import mikasaportada from '../assets/images/products/mikasa-portada.jpeg';
import mikasa1 from '../assets/images/products/mikasa1.jpeg';
import mikasa2 from '../assets/images/products/mikasa2.jpeg';
import mikasa3 from '../assets/images/products/mikasa3.jpeg';
import mikasa4 from '../assets/images/products/mikasa4.jpeg';
import paralelasportada from '../assets/images/products/paralelas-portada.jpeg';
import paralelas1 from '../assets/images/products/paralelas1.jpeg';
import paralelas2 from '../assets/images/products/paralelas2.jpeg';
import paralelas3 from '../assets/images/products/paralelas3.jpeg';
import paralelas4 from '../assets/images/products/paralelas4.jpeg';
// import magnesioportada from '../assets/images/products/magnesio-portada.jpeg';
// import magnesio1 from '../assets/images/products/magnesio1.jpeg';
// import magnesio2 from '../assets/images/products/magnesio2.jpeg';
// import magnesio3 from '../assets/images/products/magnesio3.jpeg';
// import magnesio4 from '../assets/images/products/magnesio4.jpeg';
import audifonosbtportada from '../assets/images/products/audifonosbt-portada.jpeg';
import audifonosbt1 from '../assets/images/products/audifonosbt1.jpeg';
import audifonosbt2 from '../assets/images/products/audifonosbt2.jpeg';
import audifonosbt3 from '../assets/images/products/audifonosbt3.jpeg';
import audifonosbt4 from '../assets/images/products/audifonosbt4.jpeg';
import irrigadorportada from '../assets/images/products/irrigador-portada.jpeg';
import irrigador1 from '../assets/images/products/irrigador1.jpeg';
import irrigador2 from '../assets/images/products/irrigador2.jpeg';
import irrigador3 from '../assets/images/products/irrigador3.jpeg';
import irrigador4 from '../assets/images/products/irrigador4.jpeg';
// import mecanicoportada from '../assets/images/products/mecanico-portada.jpeg';
// import mecanico1 from '../assets/images/products/mecanico1.jpeg';
// import mecanico2 from '../assets/images/products/mecanico2.jpeg';
// import mecanico3 from '../assets/images/products/mecanico3.jpeg';
// import mecanico4 from '../assets/images/products/mecanico4.jpeg';
import parlanteportada from '../assets/images/products/parlante-portada.jpeg';
import parlante1 from '../assets/images/products/parlante1.jpeg';
import parlante2 from '../assets/images/products/parlante2.jpeg';
import parlante3 from '../assets/images/products/parlante3.jpeg';
import parlante4 from '../assets/images/products/parlante4.jpeg';
import bandasportada from '../assets/images/products/bandas-portada.jpeg';
import bandas1 from '../assets/images/products/bandas1.jpeg';
import bandas2 from '../assets/images/products/bandas2.jpeg';
import bandas3 from '../assets/images/products/bandas3.jpeg';
import bandas4 from '../assets/images/products/bandas4.jpeg';
import bandas5 from '../assets/images/products/bandas5.jpeg';
import spitfireportada from '../assets/images/products/spitfire-portada.jpeg';
import spitfire1 from '../assets/images/products/spitfire1.jpeg';
import spitfire2 from '../assets/images/products/spitfire2.jpeg';
import spitfire3 from '../assets/images/products/spitfire3.jpeg';
import spitfire4 from '../assets/images/products/spitfire4.jpeg';
import packmouseportada from '../assets/images/products/pack-mouse.jpeg'
import afeitadoraportada from '../assets/images/products/afeitadora-portada.jpeg';
import afeitadora1 from '../assets/images/products/afeitadora1.jpeg';
import afeitadora2 from '../assets/images/products/afeitadora2.jpeg';
import afeitadora3 from '../assets/images/products/afeitadora3.jpeg';
import mouseportada from '../assets/images/products/mouse-portada.jpg';
import mouse1 from '../assets/images/products/mouse1.jpg';
import mouse2 from '../assets/images/products/mouse2.jpg';
import mousepadportada from '../assets/images/products/mousepad-portada.jpg';
import mousepad1 from '../assets/images/products/mousepad1.jpg';
import mousepad2 from '../assets/images/products/mousepad2.jpg';
import mousepad3 from '../assets/images/products/mousepad3.jpg';
import rodamientoportada from '../assets/images/products/rodamiento-portada.jpg';
import rodamiento1 from '../assets/images/products/rodamiento1.jpg';
import ruedaportada from '../assets/images/products/rueda-portada.jpg';
import skateportada from '../assets/images/products/skate-portada.jpg';
import skate1 from '../assets/images/products/skate1.jpg';
import skate2 from '../assets/images/products/skate2.png';
import tablaportada from '../assets/images/products/tabla-portada.jpg';
import tabla1 from '../assets/images/products/tabla1.jpg';
import tabla2 from '../assets/images/products/tabla2.jpg';
import trucksportada from '../assets/images/products/trucks-portada.jpg';
import trucks1 from '../assets/images/products/truck1.jpg';
import tecladoportada from '../assets/images/products/teclado-portada.jpg';
import teclado1 from '../assets/images/products/teclado1.jpg';
import teclado2 from '../assets/images/products/teclado2.jpg';
import respiradorportada from '../assets/images/products/respirador-portada.jpg';
import respirador1 from '../assets/images/products/respirador1.jpg';
import respirador2 from '../assets/images/products/respirador2.jpg';
// import cargadororiginalsamsungportada from '../assets/images/products/cargadororiginalsamsung-portada.jpg';
// import cargadororiginalsamsung1 from '../assets/images/products/cargadororiginalsamsung1.jpeg';
// import cargadororiginalsamsung2 from '../assets/images/products/cargadororiginalsamsung2.jpeg';
// import cargadororiginalsamsung3 from '../assets/images/products/cargadororiginalsamsung3.jpeg';
// import cargadororiginalsamsung4 from '../assets/images/products/cargadororiginalsamsung4.jpeg';
import cargadorsamportada from '../assets/images/products/cargadorsam-portada.jpg';
import cargadorsam1 from '../assets/images/products/cargadorsam1.jpg';
import cargadorsam2 from '../assets/images/products/cargadorsam2.jpg';
import cargadorsam3 from '../assets/images/products/cargadorsam3.jpg';
import mouseinportada from '../assets/images/products/mousein-portada.jpg';
import mousein1 from '../assets/images/products/mousein1.jpg';
import mousein2 from '../assets/images/products/mousein2.jpg';
import mousein3 from '../assets/images/products/mousein3.jpg';
import rubik3x3portada from '../assets/images/products/rubik3x3-portada.jpg';
import rubik3x31 from '../assets/images/products/rubik3x3-1.jpeg';
import rubik3x32 from '../assets/images/products/rubik3x3-2.jpeg';
import rubik3x33 from '../assets/images/products/rubik3x3-3.jpeg';
import rubik3x34 from '../assets/images/products/rubik3x3-4.jpeg';
import rubik2x2portada from '../assets/images/products/rubik2x2-portada.jpg';
import rubik2x21 from '../assets/images/products/rubik2x2-1.jpeg';
import rubik2x22 from '../assets/images/products/rubik2x2-2.jpeg';
import rubik2x23 from '../assets/images/products/rubik2x2-3.jpeg';
import rubik2x24 from '../assets/images/products/rubik2x2-4.jpeg';


export const products = [
  // Tecnología - Computadoras
    {
    id: 16,
    name: "Cargador ORIGINAL Xiaomi 120W Carga rápida / Hyper charge",
    price: "$16.000",
    description: "Cargador original nuevo Xiaomi , Hyper charge de 120W, Carga super rápida",
    categoryId: 1,
    subcategoryId: 102,
    images: [cargador120wportada, cargador120w1, cargador120w2, cargador120w3, cargador120w4, cargador120w5, cargador120w6],
  },



      {
    id: 17,
    name: "Cargador ORIGINAL Xiaomi 67W Carga rápida /Hyper Charge",
    price: "$14.000",
    description: "Cargador original nuevo Xiaomi, Hyper charge de 67W Carga super rápida ",
    categoryId: 1,
    subcategoryId: 102,
    images: [cargador67wportada, cargador67w1, cargador67w2, cargador67w3, cargador67w4, cargador67w5, cargador67w6],
  },

  //       {
  //   id: 25,
  //   name: "Cargador ORIGINAL Samsung, Carga SUPER rápida 45W",
  //   price: "$18.000",
  //   description: "Cargador original Samsung 45W cara super rápido, cable 1.8M ",
  //   categoryId: 1,
  //   subcategoryId: 102,
  //   images: [cargadororiginalsamsungportada, cargadororiginalsamsung1, cargadororiginalsamsung2, cargadororiginalsamsung3, cargadororiginalsamsung4],
  // },

          {
    id: 28,
    name: "Audífonos Bluetooth inalámbricos In-Ear LENOVO",
    price: "$8.000",
    description: "audífonos Bluetooth Lenovo, cómodos incluyen envase para cargar ",
    categoryId: 1,
    subcategoryId: 102,
    images: [audifonosbtportada, audifonosbt1, audifonosbt2, audifonosbt3, audifonosbt4],
  },

    {
    id: 19,
    name: "Parlante Bluetooth inalámbrico Lenovo",
    price: "$12.000",
    description: "Batería de 1200mah es pequeño, facil de transportar a todos lados",
    categoryId: 1,
    subcategoryId: 102,
    images: [parlanteportada, parlante1, parlante2, parlante3, parlante4],
  },

    {
    id: 14,
    name: "Cargador carga rápida PARA Samsung 45W",
    price: "$8.500",
    description: "Cargador carga rápida para celulares Samsung de 45W, Samsung Galaxy S24 S23 Ultra Note 10 Plus",
    categoryId: 1,
    subcategoryId: 102,
    images: [cargadorsamportada, cargadorsam1, cargadorsam2, cargadorsam3],
  },

  {
    id: 3,
    name: "Cargador Rápido tipo C Turbo PARA Xiaomi 67W",
    price: "$8.000",
    description: "Cargador carga rápida 67W, compatible con dispotivos Xiaomi",
    categoryId: 1,
    subcategoryId: 102,
    images: [cargadorportada, cargador1, cargador2, cargador3],
  },
        {
    id: 15,
    name: "Mouse inalámbrico gamer, ergonómico",
    price: "$6.500",
    description: "Mouse inalámbrico funciona por usb, tiene control dpi 1600, 6 botones y es silencioso ",
    categoryId: 1,
    subcategoryId: 102,
    images: [mouseinportada, mousein1, mousein2, mousein3],
  },

  //           {
  //   id: 22,
  //   name: "Teclado sensación mecánico gamer retro iluminado RGB Ergonómico",
  //   price: "$19.000",
  //   description: "Teclado sensación mecánico, gamer retro iluminado ergonómico, sin teclado numérico, tamaño pequeño",
  //   categoryId: 1,
  //   subcategoryId: 103,
  //   images: [mecanicoportada, mecanico1, mecanico2, mecanico3, mecanico4],
  // },
    {
    id: 12,
    name: "Kit Teclado y Mouse inalámbrico Bluetooth RGB",
    price: "$18.000",
    description: "Teclado + Mouse inalámbricos, con control de iluminación ( trae varios colores ), Compatible con iPad, IOS, Android, Windows y PC",
    categoryId: 1,
    subcategoryId: 202,
    images: [tecladoportada, teclado1, teclado2],
  },
  {
    id: 1,
    name: "Audífonos gomitas 3.5mm, micrófono y control de volumen",
    price: "$3.500",
    description: "Tienen control de volumen y micrófono incluído Colores blanco y negro",
    categoryId: 1,
    subcategoryId: 101,
    images: [audifonosgomitaportada, audifonosgomita1, audifonosgomita2],
  },

  {
    id: 2,
    name: "Audífonos in-ear, 3.5mm, micrófono y control de volumen",
    price: "$4.000",
    description: "Audífonos con control de volumen + micrófono y diseño ergonómico con cable 3.5mm, color blanco y negro",
    categoryId: 1,
    subcategoryId: 102,
    images: [audifonosinearportada, audifonosinear1, audifonosinear2],
  },

  {
    id: 4,
    name: "Mouse Gamer 800/1200/ 1600 Dpi",
    price: "$4.000",
    description: "Mouse Gamer, cuenta con control de DPI 800/1200/1600",
    categoryId: 1,
    subcategoryId: 102,
    images: [mouseportada, mouse1, mouse2],
  },

  //   // Deportes - Fútbol
          {
    id: 26,
    name: "Pelota Voleibol Mikasa v200W ORIGINAL NUEVA",
    price: "$45.000",
    description: "Pelota nueva y original Mikasa de voleibol modelo v200W ",
    categoryId: 2,
    subcategoryId: 103,
    images: [mikasaportada, mikasa1, mikasa2, mikasa3, mikasa4],
  },

            {
    id: 27,
    name: "Mini paralelas de madera CALISTENIA rectas",
    price: "$18.000",
    description: "Mini paralelas de 20cm, rectas de madera, incluyen cintas y Anti deslizante",
    categoryId: 2,
    subcategoryId: 103,
    images: [paralelasportada, paralelas1, paralelas2, paralelas3, paralelas4],
  },

              {
    id: 30,
    name: "Pack Bandas elásticas de resistencia entrenamiento calistenia / gym (También se vende por separado)",
    price: "$32.000",
    description: "Precios por separado: -Roja: $4.500, -Negra:$7.500, -Morada: $10.500, -Verde: $15.000",
    categoryId: 2,
    subcategoryId: 103,
    images: [bandasportada, bandas1, bandas2, bandas3, bandas4, bandas5],
  },

              {
    id: 31,
    name: "Pack Rudas + Rodamientos Spitfire Fórmula four (Por separado tambien se vende)",
    price: "$50.000",
    description: "Pack Spitfire, rodamientos classic, características de las ruedas: 52mm 33mm y 99d, también se pueden comprar por separado: - Rodamientos: $18.000, - Ruedas $35.000",
    categoryId: 2,
    subcategoryId: 103,
    images: [spitfireportada, spitfire1, spitfire2, spitfire3, spitfire4],
  },
  //             {
  //   id: 28,
  //   name: "Magnesio liquido Deporte ( mejora agarre )",
  //   price: "$8.000",
  //   description: "Magnesio liquido de 100ml, para levantamiento de pesas gimnasio, anillas y calistenia",
  //   categoryId: 2,
  //   subcategoryId: 103,
  //   images: [magnesioportada, magnesio1, magnesio2, magnesio3, magnesio4],
  // },
  {
    id: 9,
    name: "Skate Nuevo, armado 8 pulgadas, diseños variados",
    price: "$40.000",
    description: "Skate armado completo, nuevo, para niños y principiantes del skate, características: Tabla: 8 pulgadas, madera de mapple, 7 capas. Truck: 5 pulgadas/21cm, negro con rojo Rodamientos: ABEC 9 Ruedas: 95A, 52mm, blanca **NO INCLUYE GARANTIA**",
    categoryId: 2,
    subcategoryId: 202,
    images: [skateportada, skate1, skate2],
  },
  {
    id: 10,
    name: "Tablas de Skate 8 pulgadas, diseños varios",
    price: "$14.000",
    description: "Se vende tabla de skate 8 pulgadas, para niños y principiantes, madera de mapple 7 capas, diseños varios NO INCLUYE LIJA, valor con lija 16.000 ( no viene instalada ) **NO INCLUYE GARANTIA**",
    categoryId: 2,
    subcategoryId: 202,
    images: [tablaportada, tabla1, tabla2],
  },
  {
    id: 11,
    name: "Truck Skate 5 pulgadas",
    price: "$10.000",
    description: "Trucks 21cm, color negro con rojo, incluyen 2 trucks(para 1 skate) y tornillos necesarios para su instalación",
    categoryId: 2,
    subcategoryId: 202,
    images: [trucksportada, trucks1]
  },
  {
    id: 7,
    name: "Rodamientos Skate ABEC 9",
    price: "$7.000",
    description: "Rodamientos ABEC 9 para skate",
    categoryId: 2,
    subcategoryId: 201,
    images: [rodamientoportada, rodamiento1],
  },
  {
    id: 8,
    name: "Ruedas Skate 52mm 95A",
    price: "$7.000",
    description: "Ruedas 95A 52mm para skate, color blanca",
    categoryId: 2,
    subcategoryId: 201,
    images: [ruedaportada],
  },

 //OTROS

  {
    id: 32,
    name: "Cubo Rubik 3x3 Profesional",
    price: "$8.000",
    description: "Cubo rapido y ligero con cortes de esquinas",
    categoryId: 3,
    subcategoryId: 103,
    images: [rubik3x3portada, rubik3x31, rubik3x32, rubik3x33, rubik3x34],
  },

  {
    id: 33,
    name: "Cubo Rubik 2x2 Profesional",
    price: "$8.000",
    description: "Cubo rapido y ligero con cortes de esquinas",
    categoryId: 3,
    subcategoryId: 103,
    images: [rubik2x2portada, rubik2x21, rubik2x22, rubik2x23, rubik2x24],
  },

  {
    id: 13,
    name: "Dilatador Nasal Anti Ronquido Magnetico Tiras Nariz",
    price: "$8.500",
    description: "Tiras nasales magnéticas  anti ronquidos y dilatador nasal que ayuda a aumentar el oxigeno y disminuir resequedad, contiene 30 parches magnéticos",
    categoryId: 3,
    subcategoryId: 202,
    images: [respiradorportada, respirador1, respirador2],
  },

          {
    id: 18,
    name: "Afeitadora / Recortadora de pelo electrica recargable",
    price: "$7.000",
    description: "Máquina para cortar el pelo, incluye 4 peines 3mm, 1.5mm, 4mm y 2mm, y cable para cargar USB",
    categoryId: 3,
    subcategoryId: 102,
    images: [afeitadoraportada, afeitadora1, afeitadora2, afeitadora3],
  },

  //       {
  //   id: 21,
  //   name: "Botella de Agua con pajita 750ML, color negro mate",
  //   price: "$8.500",
  //   description: "Botella de agua 750ml con pajita para tomar, diseño color negro mate con dorado",
  //   categoryId: 3,
  //   subcategoryId: 103,
  //   images: [botellaportada, botella1, botella2, botella3, botella4],
  // },

            {
    id: 23,
    name: "Irrigador bucal / Hilo dental de agua, NO usa baterías",
    price: "$7.000",
    description: "Irrigador bucal de agua, funciona como hilo dental sin dañar la encía para nada, no usa baterías.",
    categoryId: 3,
    subcategoryId: 103,
    images: [irrigadorportada, irrigador1, irrigador2, irrigador3, irrigador4],
  },

        {
    id: 20,
    name: "Pack Mouse + Mousepad ergonómico",
    price: "$6.000",
    description: "Se vende kit / pack de mouse con control de DPI y mousepad ergonómico  ",
    categoryId: 3,
    subcategoryId: 102,
    images: [packmouseportada, mousepadportada, mouseportada, mouse1],
  },
    {
    id: 5,
    name: "Mousepad ergonómico",
    price: "$2.500",
    description: "Mousepad con diseño ergonómico, color celeste y negro ",
    categoryId: 3,
    subcategoryId: 103,
    images: [mousepadportada, mousepad1, mousepad2, mousepad3],
  },
];